import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { deleteUser } from 'src/api/apis';
import { TokenExpiredError } from 'src/api/error';
import { CURRENT_USER_ROLE } from 'src/hooks/useLogin';
import { ROLES, ROUTES } from 'src/utils/constant';
import { type UserPayload } from 'src/utils/type';
import { userDialogSx } from './styles';

import { useTranslation } from 'react-i18next';

export default function DeleteDialog ({
  user,
  onClose,
  afterDeleteUser,
  closeAll,
}: {
  user: UserPayload;
  onClose: () => void;
  afterDeleteUser: (deletUser: any) => void;
  closeAll: () => void;
}) {
  const { t } = useTranslation();
  const history = useHistory();
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [cannotDelete, setCannotDelete] = useState<boolean>(user.login !== '');
  const [deleteErrorMsg, setErrorMsg] = useState<string>(' has login can not delete.');
  const currentRole = sessionStorage.getItem(CURRENT_USER_ROLE);
  const isDeleteSuccess = confirmDelete;
  const onDelete = async () => {
    if (
      (currentRole === ROLES.platformAdmin && (user.role === ROLES.departmentAdmin || user.role === ROLES.trainee)) ||
      (currentRole === ROLES.departmentAdmin && user.role === ROLES.trainee)
    ) {
      deleteUser(user.uid)
        .then(response => {
          if (response.data.status !== '1') {
            setErrorMsg(response.statusText);
            setCannotDelete(true);
          } else {
            setConfirmDelete(true);
            afterDeleteUser(user.email);
          }
        })
        .catch(err => {
          if (err instanceof TokenExpiredError) {
            history.push(ROUTES.login);
          } else {
            setErrorMsg(err);
          }
        });
    }
  };

  const onConfirm = () => {
    if (user.login === '') {
      onDelete();
    } else {
      setCannotDelete(true);
    }
  };

  return (
    <Dialog open={true} sx={userDialogSx} onClose={closeAll} maxWidth="md">
      <DialogTitle>
        {isDeleteSuccess && !cannotDelete ? t('Delete User successfully') : t('Delete User')}{' '}
        <i className="bi bi-x" onClick={onClose} />
      </DialogTitle>
      <DialogContent>
        {!isDeleteSuccess && !cannotDelete && (
          <div className="confirm-row" style={{ color: '#006EC2', justifyContent: 'center', fontWeight: 'bold' }}>
            {t('delete_user', { uid: user.uid })}
          </div>
        )}
        {isDeleteSuccess && !cannotDelete && (
          <div className="confirm-row" style={{ color: '#006EC2', justifyContent: 'center', fontWeight: 'bold' }}>
            {t('User was Delete')}
          </div>
        )}
        {cannotDelete && (
          <div className="confirm-row" style={{ color: '#006EC2', justifyContent: 'center', fontWeight: 'bold' }}>
            {t('User')}: {user.uid} {deleteErrorMsg}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <div>
          {!isDeleteSuccess && (
            <Button variant="contained" onClick={onClose} style={{ marginRight: '16px' }}>
              {t('Return')}
            </Button>
          )}
          {!cannotDelete && (
            <Button
              variant="contained"
              onClick={isDeleteSuccess ? closeAll : onConfirm}
              style={{ marginRight: '16px' }}
            >
              {isDeleteSuccess ? t('Return') : t('Confirm')}
            </Button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
}
